// @flow
/** @jsx isolateComponent */

import TeamLogo from '@zapier/team/src/components/TeamLogo';
import {
  Avatar,
  Button,
  GridCell,
  GridLayout,
  Text,
} from '@zapier/common-components';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';

import type {
  ShareMemberType,
  SharedMemberObjectType,
} from '@zapier/team/src/types';

type Props = {
  ...$Exact<ShareMemberType>,
  canEdit: boolean,
  isDisabled?: boolean,
  onRemove: (id: string | number, type: SharedMemberObjectType) => void,
};

const Styles = labelStyles(__filename, {
  root: props => [
    {},
    props.isDisabled &&
      withModifier('isDisabled', {
        opacity: 0.5,
      }),
  ],
  image: {
    display: 'flex',
  },
});

const ShareMember = (props: Props) => {
  const Image = props.type === 'member' ? Avatar : TeamLogo;

  return (
    <article css={Styles.root(props)}>
      <GridLayout
        alignItems="center"
        areas={`
        "avatar name"
        "remove remove"
      `}
        columns="36px 1fr"
        gap={8}
        propsQueries={{
          tabletLandscapePlus: {
            areas: '"avatar name remove"',
            columns: '36px 1fr 98px',
            gap: 12,
          },
        }}
      >
        <GridCell area="avatar">
          <div css={Styles.image}>
            <Image name={props.name} size={36} url={props.imageUrl} />
          </div>
        </GridCell>
        <GridCell area="name">
          <GridLayout rows="21px 1fr">
            <Text type="body-strong">
              {props.name}
              {props.isDisabled
                ? props.role === 'shareOwner'
                  ? ' (Owner already has access)'
                  : ' (Admins already have access)'
                : ''}
            </Text>
            <Text type="body">{props.description}</Text>
          </GridLayout>
        </GridCell>
        <GridCell area="remove">
          {props.canEdit && props.role !== 'shareOwner' && (
            <Button
              isSlim={true}
              onClick={() => props.onRemove(props.id, props.type)}
            >
              Remove
            </Button>
          )}
        </GridCell>
      </GridLayout>
    </article>
  );
};

export default ShareMember;
